const URL =
  'https://micrositios.dian.gov.co/regimen-simple-tributacion/quienes-pueden-optar-por-el-simple/';

export { URL };
